import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { Item } from '@radix-ui/react-dropdown-menu'
import { styled } from '@moonpig/launchpad-utils'
import { Filter, FilterItem } from '../../../../services/types/services'
import { mapFilterItem } from '../../../../utils/GalleryFiltering/mappings'

const StyledDropdownItem = styled(Item)`
  &:focus-visible {
    outline: none;
    ${s({
      bgcolor: 'colorBackground02',
      borderColor: 'colorBlack05',
      color: 'colorInteractionFocusIndicator',
    })}
  }
`

type Props = {
  filterItem: FilterItem
  onClick: (filter: FilterItem, select?: boolean) => void
  level: number
}

export const DesktopDropdownItem: FC<Props> = ({
  filterItem,
  onClick,
  level,
}) => {
  /* istanbul ignore next */
  const getFilterItemKey = (filterItem as Filter).id || filterItem.label

  const handleSelect = (event: Event) => event.preventDefault()

  const handleKeyDown = (event: React.KeyboardEvent) => {
    /* istanbul ignore else */
    if (['Enter', ' '].includes(event.key)) {
      onClick(filterItem, !(filterItem as Filter).isSelected)
    }
  }

  return (
    <StyledDropdownItem
      data-testid={`quick-filter-dropdown-item-${getFilterItemKey}`}
      key={getFilterItemKey}
      onSelect={handleSelect}
      onKeyDown={handleKeyDown}
    >
      {mapFilterItem({
        filterItem,
        onClick,
        indentation: 8,
        level: level + 1,
      })}
    </StyledDropdownItem>
  )
}
